import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class CustomMessageService {
  constructor(private readonly messageService: MessageService) {}

  showSuccessMessage(message: string, life: number = 3000): void {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: message, life });
  }

  showErrorMessage(message: string, life: number = 3000): void {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message, life });
  }

  showInfoMessage(message: string, life: number = 3000): void {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: message, life });
  }
}
